import React from "react";
import { PDFDocument } from "pdf-lib";
import { connect } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Loader from "react-loader-spinner";
import { useState, useEffect, useRef } from "react";
import { InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
import { serverApi, parseDate } from '../../../global/globalFunctions';
import moment from 'moment';
import {
  getCourtFormData,
  getFormsPetitionPacket,
  getFormsServedSpouse,
  putDocumentsServed,
  putHowPetitionPacketServed,
  putServerAddress,
  putRegisteredCaliforniaServer,
  putDocumentsMailedCityState,
  putDateDocumentsMailed,
  putDocumentsMailedAddress,
  putCaliforniaSheriffMarshalConstable,
  putPostOfPersonServedSpouse,
  putServerDetails,
  putIncludingForms,
  putCaseNumber,
  startCourtServing,
  PutPetitioner,
  putFilledPetitionPacket,
  putServedPetitionPacket,
} from "./servingCourt.actions";
import { isEmpty, remove, filter, isUndefined, forEach } from "lodash";
import {
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Collapse,
  CustomInput,
  ModalBody,
  Modal,
} from "reactstrap";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  actionsContainer: {
    marginBottom: theme.spacing(2),
  },
  resetContainer: {
    padding: theme.spacing(3),
  },
}));

//COMPONENT

const ServingCourtForm = (props) => {

  // const additionalFormRef = useRef("");
  //Component Level States
  const [filledPetitionPacket, setFilledPetitionPacket] = useState(false);
  const [servedPetitionPacket, setservedPetitionPacket] = useState(false);
  const [isPersonalService, setPersonalService] = useState(props.howPetitionPacketServed.defaultSelected == "1" ? 1 : 0);
  const [isSubstitutedService, setSubstitutedService] = useState(props.howPetitionPacketServed.defaultSelected == "2" ? 1 : 0);
  const [isMailed, setMailed] = useState(props.howPetitionPacketServed.defaultSelected == "3" ? 1 : 0);
  const [isOther, setOther] = useState(props.howPetitionPacketServed.defaultSelected == "4" ? 1 : 0);
  const [
    petitionPacketReceivingPlace,
    setpetitionPacketReceivingPlace,
  ] = useState("false");
  const [isMailedOutOfCalifronia, setMailedOutOfCalifronia] = useState("0");
  const [
    isSheriffMarshalGovernmentEmployee,
    setSheriffMarshalGovernmentEmployee,
  ] = useState(false);
  const [isAttorneyEmployee, setAttorneyEmployee] = useState(false);
  const [isCourtEmployee, setCourtEmployee] = useState(false);
  const [isPrivateInvestigator, setPrivateInvestigator] = useState(false);
  const [isPhotoCopier, setPhotoCopier] = useState(false);
  const [isRegisterCaliforniaServer, setRegisterCaliforniaServer] = useState(props.serverRegistration.no.isServerCaliforniaRegistered === 1 ? 1 : 0);
  const [isServerPost, setServerPost] = useState("0");
  const [
    isServerSheriffMarshalConstable,
    setServerSheriffMarshalConstable,
  ] = useState("0");
  const [FL, setFL] = useState([]);
  const [show, setShow] = useState(false);
  const [additionalFormsSpecify, setAdditionalFormsSpecify] = useState("");
  const handleShow = () => setShow(true);
  const handleClose = () => setShow(false);
  const petitionerDetails = props.petitioner;
  const respondentDetails = props.respondent;
  const courtDetails = props.court;
  useEffect(() => {
    props.getCourtFormData({
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    props.startCourtServing({
      userId: window.localStorage.getItem("user_id"),
      divorce_id: window.localStorage.getItem("divorce_id"),
    });
    arrayCBOne();
  }, []);

  function saveByteArray(reportName, byte) {
    var blob = new Blob([byte], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    var fileName = reportName;
    link.download = fileName;
    link.click();
  }

  async function myFunctionFL_117() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-117`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());
    var bytes = new Uint8Array(existingPdfBytes);
    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const form = pdfDoc.getForm();


    !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("sAddress").setText(petitionerDetails.streetAddress);
    !isUndefined(petitionerDetails) && form.getField("city").setText(petitionerDetails.city);

    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);


    !isEmpty(petState) && form.getField("state").setText(petState[0].state_name);
    !isUndefined(petitionerDetails) && form.getField("zip").setText(petitionerDetails.zip);
    !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
    !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);

    !isUndefined(courtDetails) && form.getField("streetAddress").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailAddress").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("cityAndZip").setText(`${courtDetails.city}` + ` ` + `${courtDetails.zip}`);
    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);
    !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);


    !isUndefined(respondentDetails) && form.getField("nameIndividual").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);

    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);

    !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());

    form.getField("senderName").setText(props.serverDetails.serverName);

    !isUndefined(petitionerDetails) && form.getField("nameReceipt").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);



    form.getField("dateMailing").setText(parseDate(props.howPetitionPacketServed.serverMailed.dateServerMailed));

    if (!isEmpty(FL) || !isEmpty(props.otherSelectedPetitionFormsSpecify)) {
      form.getCheckBox("d").check();
    } else {
      form.getCheckBox("d").uncheck();
    }
    if (FL.includes("1")) {
      form.getCheckBox("FL105").check();
    } else {
      form.getCheckBox("FL105").uncheck();

    }
    if (FL.includes("2")) {
      form.getCheckBox("FL140").check();
    } else {
      form.getCheckBox("FL140").uncheck();

    }
    if (FL.includes("3")) {
      form.getCheckBox("FL142").check();
    } else {
      form.getCheckBox("FL142").uncheck();
    }
    if (FL.includes("4")) {
      form.getCheckBox("FL150").check();
    } else {
      form.getCheckBox("FL150").uncheck();
    }
    if (FL.includes("5")) {
      form.getCheckBox("FL155").check();
    } else {
      form.getCheckBox("FL155").uncheck();
    }
    if (FL.includes("6")) {
      form.getCheckBox("FL160").check();
    } else {
      form.getCheckBox("FL160").uncheck();
    }
    if (FL.includes("7")) {
      form.getCheckBox("FL320").check();
    } else {
      form.getCheckBox("FL320").uncheck();
    }

    !isEmpty(props.otherSelectedPetitionFormsSpecify) ? form.getCheckBox("other").check() : form.getCheckBox("other").uncheck()
    if (form.getCheckBox("other").isChecked()) {
      form.getField("otherText").setText(props.otherSelectedPetitionFormsSpecify);
    } else {
      form.getField("otherText").setText("");
    }
    form.getCheckBox("family").check();


    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");
  }

  async function myFunction() {
    const existingPdfBytes = await fetch(`${serverApi}/FL-115`, {
      headers: {
        Authorization: 'BEARER ' + window.localStorage.getItem("auth_id")
      },
    }).then((res) => res.arrayBuffer());

    var bytes = new Uint8Array(existingPdfBytes);

    const pdfDoc = await PDFDocument.load(bytes, { ignoreEncryption: true, });
    const form = pdfDoc.getForm();

    const petState = !isUndefined(petitionerDetails) && filter(props.states, state => state.state_id == petitionerDetails.state);
    const resState = !isUndefined(respondentDetails) && filter(props.states, state => state.state_id == respondentDetails.state);


    !isUndefined(petitionerDetails) && form.getField("name").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(petitionerDetails) && form.getField("sAddress").setText(petitionerDetails.streetAddress);
    !isUndefined(petitionerDetails) && form.getField("city").setText(petitionerDetails.city);
    !isEmpty(petState) && form.getField("state").setText(petState[0].state_name);
    !isUndefined(petitionerDetails) && form.getField("zip").setText(petitionerDetails.zip);
    !isUndefined(petitionerDetails) && form.getField("telephone").setText(petitionerDetails.telephone);
    !isUndefined(petitionerDetails) && form.getField("email").setText(petitionerDetails.email);

    !isUndefined(courtDetails) && form.getField("address").setText(courtDetails.courtStreetAddress);
    !isUndefined(courtDetails) && form.getField("mailing").setText(courtDetails.courtMailingAddress);
    !isUndefined(courtDetails) && form.getField("cityAndZip").setText(courtDetails.city);
    !isUndefined(courtDetails) && form.getField("superior").setText(courtDetails.county);
    !isUndefined(courtDetails) && form.getField("branch").setText(courtDetails.branchName);

    !isUndefined(petitionerDetails) && form.getField("petitioner").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("respondent").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);


    !isUndefined(petitionerDetails) && form.getField("petitionerName").setText(`${petitionerDetails.firstName}` + ` ` + `${petitionerDetails.lastName}`);
    !isUndefined(respondentDetails) && form.getField("respondentName").setText(`${respondentDetails.firstName}` + ` ` + `${respondentDetails.lastName}`);

    form.getField("Served").setText(props.serverDetails.serverName);


    !isUndefined(courtDetails) && form.getField("caseNumber").setText(courtDetails.caseNumber.toString());
    !isUndefined(courtDetails) && form.getField("case").setText(courtDetails.caseNumber.toString());


    form.getCheckBox("familyLaw").check();

    props.postOfServer != "6" ? form.getCheckBox("exempt").check() : form.getCheckBox("exempt").uncheck();




    if (props.howPetitionPacketServed.defaultSelected === "1") {
      form.getCheckBox("personalServices").check()
    } else if (props.howPetitionPacketServed.defaultSelected === "2") {
      form.getCheckBox("substituted").check()
    } else if (props.howPetitionPacketServed.defaultSelected === "3") {
      form.getCheckBox("mail").check()
    } else if (props.howPetitionPacketServed.defaultSelected === "4") {
      form.getCheckBox("other").check()
    }
    else if (props.howPetitionPacketServed.defaultSelected === "-1") {
      form.getCheckBox("personalServices").uncheck()
      form.getCheckBox("substituted").uncheck()
      form.getCheckBox("mail").uncheck()
      form.getCheckBox("other").uncheck()
    }

    if (props.howPetitionPacketServed.defaultSelected == "1") {
      form.getField("R_Address").setText(props.howPetitionPacketServed.personalService.serverServedPetitionAddress);
    } else if (props.howPetitionPacketServed.defaultSelected == "2") {
      form.getField("R_Address").setText(props.howPetitionPacketServed.substitutedService.petitionPacketCopyAddress);
    } else if (props.howPetitionPacketServed.defaultSelected == "3") {
      form.getField("R_Address").setText(props.howPetitionPacketServed.serverMailed.serverAddress);
    }



    if (form.getCheckBox("personalServices").isChecked()) {
      form.getField("P_date").setText(props.howPetitionPacketServed.personalService.serverServedPetitionPacketDate == "1947-01-01" ? "" : parseDate(props.howPetitionPacketServed.personalService.serverServedPetitionPacketDate));
      form.getField("P_time").setText(moment(props.howPetitionPacketServed.personalService.serverServedPetitionPacketTime, ["HH.mm"]).format("hh:mm a"));
    }

    else if (form.getCheckBox("substituted").isChecked()) {
      form.getField("S_name").setText(props.howPetitionPacketServed.substitutedService.petitionPacketReceiverName);
      form.getField("S_relation").setText(props.howPetitionPacketServed.substitutedService.petitionPacketReceiverRelationship);
      props.howPetitionPacketServed.substitutedService.petitionPacketReceivingPlace == "0" ? form.getCheckBox("business").check() : form.getCheckBox("home").check();
      form.getField("H_date").setText(props.howPetitionPacketServed.substitutedService.petitionPacketReceivingDate == "1947-01-01" ? "" : parseDate(props.howPetitionPacketServed.substitutedService.petitionPacketReceivingDate));
      form.getField("H_time").setText(moment(props.howPetitionPacketServed.substitutedService.petitionPacketReceivingTime, ["HH.mm"]).format("hh:mm a"));
      form.getField("date").setText(props.howPetitionPacketServed.substitutedService.petitionPacketCopyMailedDate == "1947-01-01" ? "" : parseDate(props.howPetitionPacketServed.substitutedService.petitionPacketCopyMailedDate));

    }

    else if (form.getCheckBox("mail").isChecked()) {
      form.getField("M_date").setText(props.howPetitionPacketServed.serverMailed.dateServerMailed == "1947-01-01" ? "" : parseDate(props.howPetitionPacketServed.serverMailed.dateServerMailed));
      form.getField("M_city").setText(props.howPetitionPacketServed.serverMailed.mailedFromCity);
      props.howPetitionPacketServed.serverMailed.mailOutsideCalifornia == "1" ? form.getCheckBox("toAnAddress").check() : form.getCheckBox("withTwo").check();

    }

    else if (form.getCheckBox("other").isChecked()) {
      form.getField("other_Text").setText(props.howPetitionPacketServed.other.otherInput);
    }

    form.getField("personName").setText(props.serverDetails.serverName);
    form.getField("personAddress").setText(props.serverDetails.serverAddress);
    form.getField("personNumber").setText(props.serverDetails.serverPhoneNumber);

    props.serverRegistration.no.isServerCaliforniaRegistered == "0" ? form.getCheckBox("notRegistered").check() : form.getCheckBox("registered").check();

    props.serverRegistration.yes.serverType == "0" ? form.getCheckBox("employee").check() : form.getCheckBox("independent").check();
    if (form.getCheckBox("registered").isChecked()) {
      if (form.getCheckBox("employee").isChecked()) {
        form.getField("registration").setText(props.serverRegistration.yes.registrationNo);
        form.getField("country").setText(props.serverRegistration.yes.country);
        form.getField("fee").setText(props.serverRegistration.yes.servingFee);

      } else if (form.getCheckBox("independent").isChecked()) {
        form.getField("registration").setText(props.serverRegistration.yes.registrationNo);
        form.getField("country").setText(props.serverRegistration.yes.country);
        form.getField("fee").setText(props.serverRegistration.yes.servingFee);
      }
      else {
        form.getField("registration").setText("");
        form.getField("country").setText("");
        form.getField("fee").setText("");
      }
    } else {
      form.getCheckBox("employee").uncheck();
      form.getCheckBox("independent").uncheck();
    }
    if (props.isServerCaliforniaSheriff == "1") {
      form.getCheckBox("sheriff").check()
    } else {
      form.getCheckBox("penalty").check()
    }

    if (!isEmpty(FL) || !isEmpty(props.otherSelectedPetitionFormsSpecify)) {
      form.getCheckBox("at_d").check();
    } else {
      form.getCheckBox("at_d").uncheck();
    }

    if (FL.includes("1")) {
      form.getCheckBox("check_FL105").check();
    } else {
      form.getCheckBox("check_FL105").uncheck();
    }
    if (FL.includes("2")) {
      form.getCheckBox("check_FL140").check();
    } else {
      form.getCheckBox("check_FL140").uncheck();
    }
    if (FL.includes("3")) {
      form.getCheckBox("check_FL142").check();
    } else {
      form.getCheckBox("check_FL142").uncheck();
    }
    if (FL.includes("4")) {
      form.getCheckBox("check_FL150").check();
    } else {
      form.getCheckBox("check_FL150").uncheck();
    }
    if (FL.includes("5")) {
      form.getCheckBox("check_FL155").check();
    } else {
      form.getCheckBox("check_FL155").uncheck();
    }
    if (FL.includes("6")) {
      form.getCheckBox("check_FL160").check();
    } else {
      form.getCheckBox("check_FL160").uncheck();

    }
    if (FL.includes("7")) {
      form.getCheckBox("check_FL300").check();
    } else {
      form.getCheckBox("check_FL300").uncheck();
    }

    !isEmpty(props.otherSelectedPetitionFormsSpecify) ? form.getCheckBox("check_FL_Other").check() : form.getCheckBox("check_FL_Other").uncheck()

    form.getCheckBox("check_FL_Other").isChecked() ? form.getField("otherText").setText(props.otherSelectedPetitionFormsSpecify) : form.getField("otherText").setText("");

    // form.flatten();
    const pdfBytes = await pdfDoc.save();
    const pdfDataUrl = URL.createObjectURL(
      new Blob([pdfBytes], { type: "application/pdf" })
    );
    window.open(pdfDataUrl, "_blank");

  }

  const test2 = (value) => {
    if (value === 1) {
      setSheriffMarshalGovernmentEmployee(true);
      setAttorneyEmployee(false);
      setCourtEmployee(false);
      setPrivateInvestigator(false);
      setPhotoCopier(false);
    } else if (value === 2) {
      setSheriffMarshalGovernmentEmployee(false);
      setAttorneyEmployee(true);
      setCourtEmployee(false);
      setPrivateInvestigator(false);
      setPhotoCopier(false);
    } else if (value === 3) {
      setSheriffMarshalGovernmentEmployee(false);
      setAttorneyEmployee(false);
      setCourtEmployee(true);
      setPrivateInvestigator(false);
      setPhotoCopier(false);
    } else if (value === 4) {
      setSheriffMarshalGovernmentEmployee(false);
      setAttorneyEmployee(false);
      setCourtEmployee(false);
      setPrivateInvestigator(true);
      setPhotoCopier(false);
    } else {
      setSheriffMarshalGovernmentEmployee(false);
      setAttorneyEmployee(false);
      setCourtEmployee(false);
      setPrivateInvestigator(false);
      setPhotoCopier(true);
    }
  };

  const test = (value) => {
    if (value == 1) {
      setPersonalService(true);
      setSubstitutedService(false);
      setMailed(false);
      setOther(false);
    } else if (value == 2) {
      setPersonalService(false);
      setSubstitutedService(true);
      setMailed(false);
      setOther(false);
    } else if (value == 3) {
      setPersonalService(false);
      setSubstitutedService(false);
      setMailed(true);
      setOther(false);
    } else if (value == 4) {
      setPersonalService(false);
      setSubstitutedService(false);
      setMailed(false);
      setOther(true);
    }
    else {
      setPersonalService(false);
      setSubstitutedService(false);
      setMailed(false);
      setOther(false);
    }
  };

  //STEPPER
  const classes = useStyles();
  const [activeStep, setActiveStep] = React.useState(0);
  function getSteps() {
    return [
      "Petition Packet",
      "Has your spouse been served the Petition Packet?",
      "Did you include any of these other forms with your Petition packet? You must have provided a completed and a blank one. Note: none is required, except UCCJEA if you have minor children and any local forms required by your county.",
      "How was your spouse served the Petition Packet? Select one.",
      "Who served your spouse?",
      "Do any of these apply to the person that served your spouse?",
      "Is your server a registered California process server?",
      "Was your server a California sheriff, marshal or constable?",
    ];
  }
  const steps = getSteps();
  function getCheckedValue(value) {
    if (FL.includes(value)) {
      let dummyArray = FL;
      remove(dummyArray, function (val) {
        return val == value;
      });
    } else {
      let dummyArray = FL;
      dummyArray.push(value);
      setFL(dummyArray);
    }
  }

  const arrayCBOne = () => {
    let cb = [];
    forEach([1, 2, 3, 4, 5, 6, 7], (y) => {
      let z = !isEmpty(props.selectedPetitionForms) && (props.selectedPetitionForms).includes(`${y}`)
      z == true && cb.push(z == true ? `${y}` : "");
    });
    setFL(cb)
  }
  const handlePostFunc = () => {
    if (activeStep === 0) {
      props.putFilledPetitionPacket({
        divorce_id: window.localStorage.getItem("divorce_id"),
        filedPetition:
          (document.getElementById("filledPetitionPacket").value === "0" || document.getElementById("filledPetitionPacket").value === "-1")
            ? (setActiveStep(
              (prevActiveStep) => prevActiveStep === 0 && prevActiveStep + 7
            ),
              handleShow(), document.getElementById("filledPetitionPacket").value)
            : document.getElementById("filledPetitionPacket").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    }
    else if (activeStep === 1) {
      props.putServedPetitionPacket({
        divorce_id: window.localStorage.getItem("divorce_id"),
        petitionServedPacket: (document.getElementById("servedPetitionPacket").value === "0" || document.getElementById("servedPetitionPacket").value === "-1") ? (setActiveStep(
          (prevActiveStep) => prevActiveStep === 1 && prevActiveStep + 6
        ),
          handleShow(), document.getElementById("servedPetitionPacket").value)
          : document.getElementById("servedPetitionPacket").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 2) {
      props.putIncludingForms({
        divorce_id: window.localStorage.getItem("divorce_id"),
        formsPetitionalPacket: FL,
        other: document.getElementById("otherAdditionalForms").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 3) {
      props.putHowPetitionPacketServed({
        divorce_id: window.localStorage.getItem("divorce_id"),

        howSpouseServed: document.getElementById("howSpouseServed").value,

        serverServedPetitionDate:
          document.getElementById("howSpouseServed").value == "1" ? parseDate(document.getElementById("serverServedPetitionDate").value) : "",
        serverServedPetitionTime:
          document.getElementById("howSpouseServed").value == "1"
            ? document.getElementById("serverServedPetitionTime").value
            : "",
        personalServiceAddress:
          document.getElementById("howSpouseServed").value == "1"
            ? document.getElementById("serverServedPetitionAddress").value
            : "",

        petitionPacketReceiverName:
          document.getElementById("howSpouseServed").value == "2"
            ? document.getElementById("petitionPacketReceiverName").value
            : "",
        petitionPacketReceiverRelationship:
          document.getElementById("howSpouseServed").value == "2"
            ? document.getElementById("petitionPacketReceiverRelationship")
              .value
            : "",
        petitionPacketReceivingPlace:
          document.getElementById("howSpouseServed").value == "2"
            ? document.getElementById("petitionPacketReceivingPlace").value
            : "",
        petitionPacketReceivingDate:
          document.getElementById("howSpouseServed").value == "2"
            ? parseDate(document.getElementById("petitionPacketReceivingDate").value)
            : "",
        petitionPacketReceivingTime:
          document.getElementById("howSpouseServed").value == "2"
            ? document.getElementById("petitionPacketReceivingTime").value
            : "",
        petitionPacketCopyMailedDate:
          document.getElementById("howSpouseServed").value == "2"
            ? parseDate(document.getElementById("petitionPacketCopyMailedDate").value)
            : "",
        substitudeServiceAddress:
          document.getElementById("howSpouseServed").value == "2"
            ? document.getElementById("petitionPacketCopyAddress").value
            : "",

        dateServerMailed:
          document.getElementById("howSpouseServed").value == "3"
            ? parseDate(document.getElementById("dateServerMailed").value)
            : "",
        mailedFromCity:
          document.getElementById("howSpouseServed").value == "3"
            ? document.getElementById("mailedFromCity").value
            : "",
        mailedOutOfCalifornia:
          document.getElementById("howSpouseServed").value == "3"
            ? document.getElementById("mailedOutOfCalifronia").value
            : "",
        addressToMail:
          document.getElementById("howSpouseServed").value == "3"
            ? document.getElementById("serverAddressMail").value
            : "",

        servedPetitionPacketInOtherWay:
          document.getElementById("howSpouseServed").value == "4"
            ? document.getElementById("servedPetitionPacketInOtherWay").value
            : "",
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 4) {
      props.putServerDetails({
        divorce_id: window.localStorage.getItem("divorce_id"),
        spouseServerName: document.getElementById("spouseServer").value,
        spouseServerAddress: document.getElementById("serverAddress").value,
        spouseServerPhone: document.getElementById("serverPhoneNo").value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 5) {
      props.putPostOfPersonServedSpouse({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
        personServedSpouse: document.getElementById("postOfPersonServedSpouse")
          .value,
      });
    } else if (activeStep === 6) {
      props.putRegisteredCaliforniaServer({
        divorce_id: window.localStorage.getItem("divorce_id"),
        registeredCalifornia: document.getElementById(
          "registerCaliforniaServer"
        ).value,
        serverType: document.getElementById("registerCaliforniaServer").value == "1" ? document.getElementById("serverPost").value : "",
        registrationNo: document.getElementById("registerCaliforniaServer").value == "1" ? document.getElementById("registrationNumber").value : "",
        serverCountry: document.getElementById("registerCaliforniaServer").value == "1" ? document.getElementById("countyName").value : "",
        feeForServing: document.getElementById("registerCaliforniaServer").value == "1" ? document.getElementById("servingFee").value : "",
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    } else if (activeStep === 7) {
      props.putCaliforniaSheriffMarshalConstable({
        divorce_id: window.localStorage.getItem("divorce_id"),
        serverConstable: document.getElementById(
          "serverSheriffMarshalConstable"
        ).value,
        serving_court_form_Id: window.localStorage.getItem("servingCourtId"),
      });
    }
  };
  const handleNext = () => {
    handlePostFunc();
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };


  const handleBack = () => {
    setActiveStep((prevActiveStep) =>
      ((props.isFilledPetitionerPacket == "0" || props.isFilledPetitionerPacket == "-1") && prevActiveStep === 8) ? prevActiveStep - 8 :
        ((props.isSpouseServedWithPetitionPacket == "0" || props.isSpouseServedWithPetitionPacket == "-1") && prevActiveStep === 8) ? prevActiveStep - 7 :
          prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            {/* Q2 Started */}
            <FormGroup>
              <Label for="FilledPetitionPacket">
                <h5>Have you filed the Petition Packet?</h5>
              </Label>
              <Input
                defaultValue={props.isFilledPetitionerPacket}
                type="select"
                name="filledPetitionPacket"
                id="filledPetitionPacket"
                onChange={(e) =>
                  setFilledPetitionPacket(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );

      case 1:
        return (
          <div>
            {/* Q4 Started */}
            <FormGroup>
              <Label for="servedPetitionPacket">
                <h5>Has your spouse been served the Petition Packet?</h5>
              </Label>
              <Input
                defaultValue={props.isSpouseServedWithPetitionPacket}
                type="select"
                name="servedPetitionPacket"
                id="servedPetitionPacket"
                onChange={(e) =>
                  setservedPetitionPacket(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );
      case 2:
        return (
          <div>
            <FormGroup>
              <CustomInput
                id="1"
                type="checkbox"
                value="1"
                label="UCCJEA, FL-105 [Must select if you have minor children]"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("1")}
              />
              <CustomInput
                id="2"
                type="checkbox"
                value="2"
                label="Completed and blank Declaration of Disclosure (form FL-140)"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("2")}
              />
              <CustomInput
                id="3"
                type="checkbox"
                value="3"
                label="Completed and blank Schedule of Assetsand Debts (form FL-142)"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("3")}
              />
              <CustomInput
                id="4"
                type="checkbox"
                value="4"
                label="Completed and blank Income andExpense Declaration (form FL-150)"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("4")}
              />
              <CustomInput
                id="5"
                type="checkbox"
                value="5"
                label="Completed and blank Financial Statement(Simplified) (form FL-155)"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("5")}
              />
              <CustomInput
                id="6"
                type="checkbox"
                value="6"
                label="Completed and blank PropertyDeclaration (form FL-160)"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("6")}
              />
              <CustomInput
                id="7"
                type="checkbox"
                value="7"
                label="Request for Order (form ), and blank Responsive Declaration to Request for Order(form FL-320)"
                onChange={(e) => getCheckedValue(e.target.value)}
                defaultChecked={props.selectedPetitionForms.includes("7")}
              />
              <br />
              <Label for="otherAdditionalForms">Others Additional Forms Specify (if any) :</Label>
              <Input
                id="otherAdditionalForms"
                type="text"
                onChange={(e) => setAdditionalFormsSpecify(e.target.value)}
                defaultValue={props.otherSelectedPetitionFormsSpecify}
              />

            </FormGroup>
          </div>
        );
      case 3:
        return (
          <div>
            <FormGroup>
              <Input
                defaultValue={props.howPetitionPacketServed.defaultSelected}
                type="select"
                name="howSpouseServed"
                id="howSpouseServed"
                onChange={(e) => test(Number(e.target.value))}
              >
                <option selected value="-1">-- select an option --</option>
                <option value="1">Personal Service</option>
                <option value="2">Substituted Service </option>
                <option value="3">Your server mailed it</option>
                <option value="4">Other </option>
              </Input>
            </FormGroup>
            <Collapse isOpen={isPersonalService == "1"}>
              <FormGroup>
                <h5>
                  Please put in the time and date your server served the
                  Petition Packet on your spouse.
                </h5>
                <Row>
                  <Col lg={6}>
                    <Label for="date">Date</Label>
                    <Input
                      defaultValue={props.howPetitionPacketServed.personalService.serverServedPetitionPacketDate == '1947-01-01' ? "" : moment(props.howPetitionPacketServed.personalService.serverServedPetitionPacketDate).format('YYYY-MM-DD')}
                      type="date"
                      name="serverServedPetitionDate"
                      id="serverServedPetitionDate"
                    />
                  </Col>

                  <Col lg={6}>
                    <Label for="time">Time</Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.personalService.serverServedPetitionPacketTime
                      }
                      type="time"
                      name="serverServedPetitionTime"
                      id="serverServedPetitionTime"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Label for="address">Address</Label>
                    <Input
                      placeholder="Enter Complete Address"
                      type="text"
                      name="serverServedPetitionAddress"
                      id="serverServedPetitionAddress"
                      defaultValue={
                        props.howPetitionPacketServed.personalService.serverServedPetitionAddress
                      }
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Collapse>
            <Collapse isOpen={isSubstitutedService == "1"}>
              <FormGroup>
                <h5>Who did your server leave the Petition Packet with?</h5>
                <Row>
                  <Col lg={6}>
                    <Label for="petitionPacketReceiverName">Name</Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.substitutedService.petitionPacketReceiverName
                      }
                      type="text"
                      name="petitionPacketReceiverName"
                      id="petitionPacketReceiverName"
                    />
                  </Col>

                  <Col lg={6}>
                    <Label for="petitionPacketReceiverRelationship">
                      What is this person’s relationship to your spouse?
                    </Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.substitutedService.petitionPacketReceiverRelationship
                      }
                      type="text"
                      name="petitionPacketReceiverRelationship"
                      id="petitionPacketReceiverRelationship"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg={12}>
                    <Label for="petitionPacketReceivingPlace">
                      Was this at a:
                    </Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.substitutedService.petitionPacketReceivingPlace
                      }
                      type="select"
                      name="petitionPacketReceivingPlace"
                      id="petitionPacketReceivingPlace"
                      onChange={(e) =>
                        setpetitionPacketReceivingPlace(
                          JSON.parse(e.target.value)
                        )
                      }
                    >
                      <option selected value="-1">
                        -- select an option --
                      </option>
                      <option value="0">Business place</option>
                      <option value="1">Home</option>
                    </Input>
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Label for="petitionPacketReceivingDate">When</Label>
                    <Input
                      defaultValue={props.howPetitionPacketServed.substitutedService.petitionPacketReceivingDate == '1947-01-01' ? "" : moment(props.howPetitionPacketServed.substitutedService.petitionPacketReceivingDate).format('YYYY-MM-DD')}
                      type="date"
                      name="petitionPacketReceivingDate"
                      id="petitionPacketReceivingDate"
                    />
                  </Col>
                  <Col lg={6}>
                    <Label for="petitionPacketReceivingTime">What Time</Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.substitutedService.petitionPacketReceivingTime
                      }
                      type="time"
                      name="petitionPacketReceivingTime"
                      id="petitionPacketReceivingTime"
                    />
                  </Col>
                </Row>
                <Row>
                  <Col lg={6}>
                    <Label for="petitionPacketCopyMailedDate">
                      When did you mail another copy to your spouse to that
                      location?
                    </Label>
                    <Input
                      defaultValue={props.howPetitionPacketServed.substitutedService.petitionPacketCopyMailedDate == '1947-01-01' ? "" : moment(props.howPetitionPacketServed.substitutedService.petitionPacketCopyMailedDate).format('YYYY-MM-DD')}
                      type="date"
                      name="petitionPacketCopyMailedDate"
                      id="petitionPacketCopyMailedDate"
                    />
                  </Col>

                  <Col lg={6} style={{ marginTop: "24px" }}>
                    <Label for="address">Address
                    </Label>
                    <Input
                      placeholder="Enter Complete Address"
                      type="text"
                      name="petitionPacketCopyAddress"
                      id="petitionPacketCopyAddress"
                      defaultValue={
                        props.howPetitionPacketServed.substitutedService.petitionPacketCopyAddress
                      }
                    />
                  </Col>
                </Row>
              </FormGroup>
            </Collapse>

            <Collapse isOpen={isMailed == "1"}>
              <FormGroup>
                <Row>
                  <Col lg={4}>
                    <Label for="dateServerMailed">
                      What was the date you server mailed it?{" "}
                    </Label>
                    <Input
                      defaultValue={props.howPetitionPacketServed.serverMailed.dateServerMailed == '1947-01-01' ? "" : moment(props.howPetitionPacketServed.serverMailed.dateServerMailed).format('YYYY-MM-DD')}
                      type="date"
                      name="dateServerMailed"
                      id="dateServerMailed"
                    />
                  </Col>

                  <Col lg={4} style={{ marginTop: "24px" }}>
                    <Label for="mailedFromCity">
                      What city was it mailed from?{" "}
                    </Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.serverMailed.mailedFromCity
                      }
                      type="text"
                      name="mailedFromCity"
                      id="mailedFromCity"
                    />
                  </Col>

                  <Col lg={4}>
                    <Label for="mailedOutOfCalifronia">
                      Did you mail it to an address outside of California?
                    </Label>
                    <Input
                      defaultValue={
                        props.howPetitionPacketServed.serverMailed.mailOutsideCalifornia
                      }
                      type="select"
                      name="mailedOutOfCalifronia"
                      id="mailedOutOfCalifronia"
                      onChange={(e) =>
                        setMailedOutOfCalifronia(JSON.parse(e.target.value))
                      }
                    >
                      <option selected value="-1">
                        -- select an option --
                      </option>
                      <option value="1">Yes</option>
                      <option value="0">No</option>
                    </Input>
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <Label for="serverAddressMail">
                      What Address did you mail it to?{" "}
                    </Label>
                    <Input
                      type="text"
                      name="serverAddressMail"
                      id="serverAddressMail"
                      placeholder="Enter Complete Address"
                      defaultValue={
                        props.howPetitionPacketServed.serverMailed.serverAddress
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col lg="12">
                    <Label>
                      CAUTION: when you serve by mail, your server must have included 2 copies of
                      the FL-117 and a postage-paid return envelope addressed to the server.
                    </Label>
                  </Col>
                </Row>
              </FormGroup>
            </Collapse>
            <Collapse isOpen={isOther == "1"}>
              <FormGroup>
                <Label for="servedPetitionPacketInOtherWay" style={{ fontWeight: "bold" }}>What code section allows you an other option [fill in]:</Label>
                <Input
                  defaultValue={props.howPetitionPacketServed.other.otherInput}
                  type="text"
                  name="servedPetitionPacketInOtherWay"
                  id="servedPetitionPacketInOtherWay"
                />
              </FormGroup>
            </Collapse>
          </div>
        );
      case 4:
        return (
          <div>
            <FormGroup>
              <Label for="serverName">Name</Label>
              <Input
                defaultValue={props.serverDetails.serverName}
                type="text"
                name="spouseServer"
                id="spouseServer"
              />

              <Label for="serverAddress">Server's Address</Label>
              <Input
                defaultValue={props.serverDetails.serverAddress}
                type="text"
                name="serverAddress"
                id="serverAddress"
              />

              <Label for="serverPhoneNo">Server's Phone No</Label>
              <Input
                defaultValue={props.serverDetails.serverPhoneNumber}
                type="text"
                name="serverPhoneNo"
                id="serverPhoneNo"
              />
            </FormGroup>
          </div>
        );
      case 5:
        return (
          <div>
            {/* Q7 Started */}
            <FormGroup>
              <Label for="postOfPersonServedSpouse">
                <h5>Do any of these apply to the person that served your spouse?</h5>
              </Label>
              <Input
                defaultValue={props.postOfServer}
                type="select"
                name="postOfPersonServedSpouse"
                id="postOfPersonServedSpouse"
                onChange={(e) => test2(Number(e.target.value))}
              >
                <option selected value="-1">-- select an option --</option>
                <option value="1">
                  A sheriff, marshal, or government employee
                </option>
                <option value="2">
                  Your attorney or attorney’s employee providing you a legal
                  service.
                </option>
                <option value="3">
                  Appointed by a court to serve your papers
                </option>
                <option value="4">
                  A licensed private investigator or his or her employees.
                </option>
                <option value="5">
                  A professional photocopier registered under Business and
                  Professions Code Section 22350(b)
                </option>
                <option value="6">
                  None
                </option>
              </Input>
            </FormGroup>
          </div>
        );
      case 6:
        return (
          <div>
            <FormGroup>
              <Label for="registerCaliforniaServer">
                <h5>Is your server a registered California process server?</h5>
              </Label>
              <Input
                defaultValue={
                  props.serverRegistration.no.isServerCaliforniaRegistered
                }
                type="select"
                name="registerCaliforniaServer"
                id="registerCaliforniaServer"
                onChange={(e) =>
                  setRegisterCaliforniaServer(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>

            <Collapse isOpen={isRegisterCaliforniaServer == "1"}>
              <FormGroup>
                <Label for="serverPost">
                  <h5>Is your server</h5>
                </Label>
                <Input
                  defaultValue={props.serverRegistration.yes.serverType}
                  type="select"
                  name="serverPost"
                  id="serverPost"
                  onChange={(e) => setServerPost(JSON.parse("1"))}
                >
                  <option selected value="-1">-- select an option --</option>
                  <option value="0">An employee</option>
                  <option value="1">An independent contractor</option>
                </Input>
              </FormGroup>

              <FormGroup>
                <Row>
                  <Col lg={4}>
                    <Label for="registrationNumber">
                      <h5>Registration No</h5>
                    </Label>
                    <Input
                      defaultValue={props.serverRegistration.yes.registrationNo}
                      type="text"
                      name="registrationNumber"
                      id="registrationNumber"
                    />
                  </Col>

                  <Col lg={4}>
                    <Label for="countyName">
                      <h5>County</h5>
                    </Label>
                    <Input
                      defaultValue={props.serverRegistration.yes.country}
                      type="text"
                      name="countyName"
                      id="countyName"
                    />
                  </Col>

                  <Col lg={4}>
                    <Label for="servingFee">
                      <h5>The fee for serving was: </h5>
                    </Label>
                    <InputGroup>
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>$</InputGroupText>
                      </InputGroupAddon>
                      <Input
                        defaultValue={props.serverRegistration.yes.servingFee}
                        type="number"
                        name="servingFee"
                        id="servingFee"
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </FormGroup>
            </Collapse>
          </div>
        );
      case 7:
        return (
          <div>
            <FormGroup>
              <Input
                defaultValue={props.isServerCaliforniaSheriff}
                type="select"
                name="serverSheriffMarshalConstable"
                id="serverSheriffMarshalConstable"
                onChange={(e) =>
                  setServerSheriffMarshalConstable(JSON.parse(e.target.value))
                }
              >
                <option selected value="-1">-- select an option --</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
              </Input>
            </FormGroup>
          </div>
        );
      default:
        return "DEFAULT CASES...";
    }
  }

  return (
    <div className={classes.root}>
      {props.isFetchingCourtFormData ?
        <div style={{ marginLeft: "42%", marginTop: "18%" }}>
          <Loader
            type="Puff"
            color="#00BFFF"
            height={120}
            width={120}
          />
        </div>
        :
        <div>
          <Stepper activeStep={activeStep} orientation="vertical" style={{
            fontStyle: "normal",
            fontFamily: "sans-serif",
            backgroundColor: "white",
            textAlign: "justify",
            textJustify: "inter-word",
            padding: "20px 70px"
          }}>
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
                <StepContent>
                  <Typography>{getStepContent(index)}</Typography>
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        onClick={handleBack}
                        className={classes.button}
                      >
                        Back
                      </Button>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleNext}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? "Finish" : "Next"}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>All steps completed - you&apos;re finished</Typography>
              <Button onClick={handleReset} className={classes.button}>
                Reset
              </Button>
              <Button onClick={handleBack} className={classes.button}>
                Back
              </Button>
            </Paper>
          )}
          <div style={{ display: "flex", float: "right" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={myFunction}
            >
              Print FL-115
            </Button>
            {(props.howPetitionPacketServed.defaultSelected == "3") &&
              <Button
                style={{ marginLeft: "2px" }}
                variant="contained"
                color="primary"
                onClick={myFunctionFL_117}
              >
                Print FL-117
              </Button>}
          </div>
          <Modal isOpen={show} style={{ marginTop: "300px", marginLeft: "46%" }}>
            <ModalBody>Your Interview has been finished</ModalBody>
            <Button
              style={{ width: "", color: "white", backgroundColor: "Blue" }}
              onClick={handleClose}
            >
              Close
            </Button>
          </Modal>
        </div>}
    </div>
  );
};

const mapStateToProps = (state) => ({
  petitioner: state.ProfileInformationReducer.petitionerDetails,
  respondent: state.ProfileInformationReducer.respondentDetails,
  court: state.ProfileInformationReducer.court,
  filedPetition: state.petitionerPacketReducer.filedPetition,
  petitionerCheck: state.servingCourtReducer.isPetitioner,
  isFilledPetitionerPacket: state.servingCourtReducer.isFilledPetitionerPacket,
  isSpouseServedWithPetitionPacket: state.servingCourtReducer.isSpouseServedWithPetitionPacket,
  howPetitionPacketServed: state.servingCourtReducer.howPetitionPacketServed,
  serverDetails: state.servingCourtReducer.serverDetails,
  postOfServer: state.servingCourtReducer.postOfServer,
  serverRegistration: state.servingCourtReducer.serverRegistration,
  isServerCaliforniaSheriff: state.servingCourtReducer.isServerCaliforniaSheriffConstable,
  states: state.petitionerPacketReducer.states,
  isFetchingCourtFormData: state.servingCourtReducer.isFetchingCourtFormData,
  selectedPetitionForms: state.servingCourtReducer.selectedPetitionForms,
  otherSelectedPetitionFormsSpecify: state.servingCourtReducer.otherSelectedPetitionFormsSpecify,

});

const mapDispatchToProps = (dispatch) => {
  return {
    getCourtFormData: (data) => dispatch(getCourtFormData(data)),
    putHowPetitionPacketServed: (data) => dispatch(putHowPetitionPacketServed(data)),
    putRegisteredCaliforniaServer: (data) => dispatch(putRegisteredCaliforniaServer(data)),
    putCaliforniaSheriffMarshalConstable: (data) => dispatch(putCaliforniaSheriffMarshalConstable(data)),
    putPostOfPersonServedSpouse: (data) => dispatch(putPostOfPersonServedSpouse(data)),
    putServerDetails: (data) => dispatch(putServerDetails(data)),
    putIncludingForms: (data) => dispatch(putIncludingForms(data)),
    putServedPetitionPacket: (data) => dispatch(putServedPetitionPacket(data)),
    startCourtServing: (data) => dispatch(startCourtServing(data)),
    putFilledPetitionPacket: (data) => dispatch(putFilledPetitionPacket(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ServingCourtForm);
